import { Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { PageComponent } from './page/page.component';

const routes: Routes = [
  { path: 'etusivu',
    component: FrontpageComponent
  },
  { path: 'mita-ovat-energiatehokkuussopimukset',
    component: PageComponent
  },
  { path: 'ministerin-alkusanat',
    component: PageComponent
  },
  { path: 'mita-saavutimme-vuosina-2008-2016',
    component: PageComponent
  },
  { path: 'vapaaehtoisuuden-voimalla',
    component: PageComponent
  },
  { path: 'menestystekijat',
    component: PageComponent
  },
  { path: 'takana-pitka-historia',
    component: PageComponent
  },
  { path: 'valtio-tukee-energiatehokkuutta',
    component: PageComponent
  },
  { path: 'energiakatselmus-viitoittaa-tieta',
    component: PageComponent
  },
  { path: 'johtaminen-vie-eteenpain',
    component: PageComponent
  },
  { path: 'opastusta-ja-neuvontaa-kayttajille',
    component: PageComponent
  },
  { path: 'elinkeinoelama',
    component: PageComponent
  },
  { path: 'kiinteistoala',
    component: PageComponent
  },
  { path: 'kunta-ala',
    component: PageComponent
  },
  { path: 'oljyala',
    component: PageComponent
  },
  { path: 'muut-sopimusalat',
    component: PageComponent
  },
  { path: 'sopimuksiin-iittyneet',
    component: PageComponent
  },
  {
    path: '',
    redirectTo: 'etusivu',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'etusivu'
  }
];

export const Routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/routes.ts